import { type ReactNode } from "react";

import { Button } from "../ui/button";

import { env } from "@/app/utils/env";
import RobotImage from "@/assets/images/robot.png";

interface NotFoundProps {
  title?: string | ReactNode;
  subTitle?: string | ReactNode;
  image?: string;
  url?: string;
  homeUrl?: string;
}

const WorkspaceNotFound = ({
  title,
  subTitle,
  image,
  url,
  homeUrl,
}: NotFoundProps): JSX.Element => {
  return (
    <div className='flex flex-col items-center justify-center min-h-screen space-y-5 '>
      <img src={image || RobotImage} className='mx-auto h-5/6' />
      <div className='text-center'>
        <h1 className='text-3xl font-medium text-gray-800'>
          {title || "404. That’s an error."}
        </h1>
        <p className='text-gray-500'>
          {subTitle ||
            `The requested workspace ${url || "URL"} was not found on this server.`}
        </p>
        <Button
          onClick={() => {
            window.location.href = homeUrl || `${env.LANDING_PAGE}`;
          }}
          className='mt-5'
        >
          Go to Home
        </Button>
      </div>
    </div>
  );
};

export default WorkspaceNotFound;
